/* 

	RyanFosterDesign Ltd www.ryanfosterdesign.com 

*/

$(document).ready(function(){
	
	// Page Scrolling
	var scrollElement = 'html, body';
	$('html, body').each(function () {
		var initScrollTop = $(this).attr('scrollTop');
		$(this).attr('scrollTop', initScrollTop + 1);
		if ($(this).attr('scrollTop') == initScrollTop + 1) {
			scrollElement = this.nodeName.toLowerCase();
			$(this).attr('scrollTop', initScrollTop);
			return false;
		}    
	});


	// Equal hieght product grid
	equalheight = function(container){

	var currentTallest = 0,
	     currentRowStart = 0,
	     rowDivs = new Array(),
	     $el,
	     topPosition = 0;
	 $(container).each(function() {

	   $el = $(this);
	   console.log()
	   $($el).height('auto')
	   topPostion = $el.position().top;

	   if (currentRowStart != topPostion) {
	     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
	       rowDivs[currentDiv].height(currentTallest);
	     }
	     rowDivs.length = 0; // empty the array
	     currentRowStart = topPostion;
	     currentTallest = $el.height();
	     rowDivs.push($el);
	   } else {
	     rowDivs.push($el);
	     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
	  }
	   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
	     rowDivs[currentDiv].height(currentTallest);
	   }
	 });
	}

	$(window).load(function() {
	  equalheight('.product-block');
	});


	$(window).resize(function(){
	  equalheight('.product-block');
	});
	
	// Smooth scrolling for internal links
	$(document).on("click", "a[href^='#']", function(event) {
	//$("a[href^='#']").click(function(event) {
		event.preventDefault();
		
		var navHeight = $("#navbar").outerHeight();
		
		var $this = $(this),
		target = this.hash,
		$target = $(target);

		$(scrollElement).stop().animate({
			'scrollTop': $target.offset().top - navHeight
		}, 900, 'swing', function() {
			//window.location.hash = target;
		});
		
	});
	
	// check for enhanced 'feature' header tags and build drop-menu
	if ($("#product-features").length) {
		var count = 1;
		var features = [];
		$("#product-features h1, #product-features h2").each(function() {
			$(this).attr("id","feature"+count);
			var title = $(this).text()
			features.push({ 'id':'feature'+count, 'title':title });
			count++;
		});
		
		if (features.length > 0) {
			for (var i = features.length-1; i >= 0; i--) {
				$(".drop-menu").prepend('<li><a href="#' + features[i].id + '">' + features[i].title  + '</a>');
				$("#features-mobile").after('<li><a href="#' + features[i].id + '">' + features[i].title  + '</a>');
			}
			$("#features-mobile").remove();
		}
	}
	// if not the index page, check for the stored variable
	if (typeof featuredContent != 'undefined') {
		var wrapper= document.createElement('div');
		wrapper.innerHTML= featuredContent;
		count = 1;
		var features = [];
		$(wrapper).children("h1,h2").each(function() {
			var title = $(this).text()
			features.push({ 'id':'feature-'+count, 'title':title });
			count++;
		});
		if (features.length > 0) {
			for (var i = features.length-1; i >= 0; i--) {
				$(".drop-menu").prepend('<li><a href="/#' + features[i].id + '">' + features[i].title  + '</a>');
				$("#features-mobile").after('<li><a href="/#' + features[i].id + '">' + features[i].title  + '</a>');
			}	
			$("#features-mobile").remove();
		}
	}

	
	// Form Validation
	$("form.comment-form").validate();
	$("form.contact-form").validate();
	
	$("form.mini-contact-form").validate();
	if(window.location.href.indexOf("?customer_posted=true") > -1) {
		   $("p.success").addClass("show");
	    }
	
	// Placeholder fix for input fields
	$(function() {
		var input = document.createElement("input");
	    if(('placeholder' in input)==false) { 
			$('[placeholder]').focus(function() {
				var i = $(this);
				if(i.val() == i.attr('placeholder')) {
					i.val('').removeClass('placeholder');
					if(i.hasClass('password')) {
						i.removeClass('password');
						this.type='password';
					}			
				}
			}).blur(function() {
				var i = $(this);	
				if(i.val() == '' || i.val() == i.attr('placeholder')) {
					if(this.type=='password') {
						i.addClass('password');
						this.type='text';
					}
					i.addClass('placeholder').val(i.attr('placeholder'));
				}
			}).blur().parents('form').submit(function() {
				$(this).find('[placeholder]').each(function() {
					var i = $(this);
					if(i.val() == i.attr('placeholder'))
						i.val('');
				})
			});
		}
	});	
	
 })

$(window).load(function() {
	if (window.location.hash != '') {
		var hash = window.location.hash;
		if (hash.indexOf("#feature") !== -1) {
			var navHeight = $("#navbar").outerHeight();
			var scrollElement = 'html, body';
			$(scrollElement).stop().animate({
				'scrollTop': $(hash.replace("-","")).offset().top - navHeight
			}, 900, 'swing', function() { });
		}
	}
})